
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/LVMON",
      function () {
        return require("private-next-pages/LVMON.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/LVMON"])
      });
    }
  